import React, { useState, useMemo, useEffect, useRef } from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import ApparelCard from './components/ApparelCard';
import Pagination from '../../components/ui/Pagination';
import CategoryFilter from './components/CategoryFilter';
import ApparelDetailModal from './components/ApparelDetailModal';
import SearchBar from './components/SearchBar';

const ITEMS_PER_PAGE = 20;



const ApparelAndAccessories = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');
  const [selectedApparel, setSelectedApparel] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const catalogRef = useRef(null);

  React.useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, activeCategory]);

  useEffect(() => {
    if (!catalogRef.current) return;

    catalogRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }, [currentPage]);


  const categories = [
    { id: 'all', name: 'Semua Produk', icon: 'Grid3x3' },
    { id: 'shirt', name: 'Jaket & Atasan', icon: 'Shirt' },
    { id: 'backpack', name: 'Tas & Backpack', icon: 'Backpack' },
    { id: 'gloves', name: 'Sarung Tangan', icon: 'Hand' },
    { id: 'accessories', name: 'Aksesoris', icon: 'Sparkles' },
  ];


  const apparel = [
  {
    id: 1,
    name: "Cyber Wind Breaker",
    category: "Apparel",
    categoryId: "jacket",
    description:
      "Jaket windbreaker Honda dengan desain modern dan fitur fungsional untuk aktivitas harian maupun riding ringan.",
    apparelCode: "APP-CYB-WB",
    price: 480000,
    image: "/assets/apparel-aksesoris/apparel/CYBERWINDBREAKER.webp",
    imageAlt: "Cyber Wind Breaker Honda",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    specifications: [
      { label: "Material", value: "Combed Twill & Metallic Parachute Furing" },
      { label: "Feature", value: "Shoulder strap, rubber stopper hoodie & waist" },
      { label: "Finishing", value: "Rubber strap keychain" }
    ]
  },
  {
    id: 2,
    name: "Cyber Sweatshirt",
    category: "Apparel",
    categoryId: "shirt",
    description:
      "Sweatshirt Honda bergaya urban dengan material nyaman untuk penggunaan harian.",
    apparelCode: "APP-CYB-SWT",
    price: 390000,
    image: "/assets/apparel-aksesoris/apparel/CYBERSWEATSHIRT.webp",
    imageAlt: "Cyber Sweatshirt Honda",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    specifications: [
      { label: "Material", value: "Danbowl" },
      { label: "Detail", value: "Silver colored zipper" }
    ]
  },
  {
    id: 3,
    name: "Blouson Jacket",
    category: "Apparel",
    categoryId: "jacket",
    description:
      "Jaket blouson Honda dengan sentuhan premium dan material kombinasi modern.",
    apparelCode: "APP-BLS-JKT",
    price: 560000,
    image: "/assets/apparel-aksesoris/apparel/BlousonJacket.webp",
    imageAlt: "Blouson Jacket Honda",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: ["Black"],
    specifications: [
      { label: "Material", value: "Twill Combed & Synthetic Leather" },
      { label: "Furing", value: "Dormil" },
      { label: "Detail", value: "Aluminium zipper & magnetic Honda logo plate" }
    ]
  },
  {
    id: 4,
    name: "Sporty Jacket 2in1",
    category: "Apparel",
    categoryId: "jacket",
    description:
      "Jaket sporty multifungsi 2in1 Honda yang dapat digunakan sebagai cropped jacket.",
    apparelCode: "APP-SPT-2IN1",
    price: 599000,
    image: "/assets/apparel-aksesoris/apparel/SportyJacket(2in1).webp",
    imageAlt: "Sporty Jacket 2in1 Honda",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: ["Red", "White", "Black"],
    specifications: [
      { label: "Material Luar", value: "Pollytaslan" },
      { label: "Furing", value: "Quilting Peles 2 oz" },
      { label: "Finishing", value: "Bordir, polyflex reflector & scotlight" }
    ]
  },
  {
    id: 5,
    name: "CBR Chimera Jacket",
    category: "Apparel",
    categoryId: "jacket",
    description:
      "Jaket riding CBR Chimera dengan protektor dan sistem airflow untuk keamanan berkendara.",
    apparelCode: "APP-CBR-CHM",
    price: 975000,
    image: "/assets/apparel-aksesoris/apparel/CBRChimeraJacket.webp",
    imageAlt: "CBR Chimera Jacket Honda",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: ["Black"],
    specifications: [
      { label: "Material", value: "Polyester & synthetic leather (outer), soft mesh (inner)" },
      { label: "Feature", value: "Shoulder & elbow protector, airflow system" }
    ]
  },
  {
    id: 6,
    name: "Street Neon Windbreaker",
    category: "Apparel",
    categoryId: "jacket",
    description:
      "Windbreaker Honda dengan aksen neon glow in the dark untuk tampilan standout.",
    apparelCode: "APP-STR-NEON",
    price: 300000,
    image: "/assets/apparel-aksesoris/apparel/StreetNeonWindbreaker.webp",
    imageAlt: "Street Neon Windbreaker Honda",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: ["Black", "Neon"],
    specifications: [
      { label: "Material", value: "Water Repellent" },
      { label: "Detail", value: "Sablon glow in the dark" },
      { label: "Fit", value: "Regular" }
    ]
  },
  {
    id: 7,
    name: "HRC23 Elegant Navy Jacket",
    category: "Apparel",
    categoryId: "jacket",
    description:
      "Jaket HRC Honda Racing dengan tema elegant dan material premium.",
    apparelCode: "HRC23-JKT-ELG",
    price: 350000,
    image: "/assets/apparel-aksesoris/apparel/HRC23ELEGANTNAVYJACKET.webp",
    imageAlt: "HRC23 Elegant Navy Jacket",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    specifications: [
      { label: "Material", value: "Pleace CVC" },
      { label: "Design", value: "Exclusive HRC Honda Racing (Elegant)" },
      { label: "Finishing", value: "High Density & rubber print logo" }
    ]
  },
  {
    id: 8,
    name: "HRC23 Sporty Navy Jacket",
    category: "Apparel",
    categoryId: "jacket",
    description:
      "Jaket HRC Honda Racing dengan tema sporty dan detail racing look.",
    apparelCode: "HRC23-JKT-SPT",
    price: 370000,
    image: "/assets/apparel-aksesoris/apparel/HRC23SPORTYNAVYJACKET.webp",
    imageAlt: "HRC23 Sporty Navy Jacket",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    specifications: [
      { label: "Material", value: "Pleace CVC" },
      { label: "Design", value: "Exclusive HRC Honda Racing (Sporty)" },
      { label: "Finishing", value: "HD, rubber & plastisol print" }
    ]
  },
  {
    id: 9,
    name: "Elegant Leather Jacket",
    category: "Apparel",
    categoryId: "jacket",
    description:
      "Jaket kulit sintetis Honda dengan desain elegan dan kenyamanan optimal.",
    apparelCode: "APP-ELG-LTH",
    price: 402000,
    image: "/assets/apparel-aksesoris/apparel/ElegantLeatherJacket.webp",
    imageAlt: "Elegant Leather Jacket Honda",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    specifications: [
      { label: "Material", value: "Synthetic leather (outer), soft mesh (inner)" },
      { label: "Feature", value: "Inner pocket" }
    ]
  },
  {
    id: 10,
    name: "CBR Titanium Jacket",
    category: "Apparel",
    categoryId: "jacket",
    description:
      "Jaket riding premium Honda CBR dengan protektor dan airflow system.",
    apparelCode: "APP-CBR-TTN",
    price: 1119000,
    image: "/assets/apparel-aksesoris/apparel/CBRTitaniumJacket.webp",
    imageAlt: "CBR Titanium Jacket Honda",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: ["Black"],
    specifications: [
      { label: "Material", value: "Polyester & synthetic leather (outer), mesh (inner)" },
      { label: "Safety", value: "Shoulder & arm protector, airflow system" }
    ]
  },
  {
    id: 11,
    name: "Honda Parka Latte Jacket",
    category: "Apparel",
    categoryId: "jacket",
    description:
      "Jaket parka Honda dengan desain stylish dan nuansa kasual.",
    apparelCode: "APP-PRK-LAT",
    price: 392000,
    image: "/assets/apparel-aksesoris/apparel/HondaParkaLatteJacket.webp",
    imageAlt: "Honda Parka Latte Jacket",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: ["Khaki"],
    specifications: [
      { label: "Material", value: "Baby canvas cotton" },
      { label: "Detail", value: "Logo bordir & zipper pocket sleeve" }
    ]
  },
  {
    id: 12,
    name: "Honda Riding Jacket",
    category: "Apparel",
    categoryId: "jacket",
    description:
      "Jaket riding Honda dengan desain sporty racing dan fitur keselamatan.",
    apparelCode: "APP-RDG-JKT",
    price: 585000,
    image: "/assets/apparel-aksesoris/apparel/HondaRidingJacket.webp",
    imageAlt: "Honda Riding Jacket",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    specifications: [
      { label: "Material", value: "Polyester & mesh" },
      { label: "Safety", value: "Soft elbow protector & reflector 3M" },
      { label: "Ventilation", value: "Airflow system" }
    ]
  },
  {
    id: 13,
    name: "Honda Classic Jacket",
    category: "Apparel",
    categoryId: "jacket",
    description:
      "Jaket touring klasik Honda dengan protektor dan sistem ventilasi.",
    apparelCode: "APP-CLS-JKT",
    price: 341000,
    image: "/assets/apparel-aksesoris/apparel/HondaClassicJacket.webp",
    imageAlt: "Honda Classic Jacket",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL"],
    specifications: [
      { label: "Material", value: "Cotton canvas & mesh" },
      { label: "Safety", value: "Shoulder & elbow protector (soft)" }
    ]
  },
  {
    id: 14,
    name: "Cyber Shirt",
    category: "Apparel",
    categoryId: "shirt",
    description:
      "Kemeja Honda dengan gaya urban modern.",
    apparelCode: "APP-CYB-SHRT",
    price: 360000,
    image: "/assets/apparel-aksesoris/apparel/CYBERSHIRT.webp",
    imageAlt: "Cyber Shirt Honda",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    specifications: [
      { label: "Material", value: "Ripstock" },
      { label: "Detail", value: "Rubber strap keychain" }
    ]
  },
  {
    id: 15,
    name: "One Heart Vest Black",
    category: "Apparel",
    categoryId: "vest",
    description:
      "Vest One Heart Honda dengan desain simpel dan fungsional.",
    apparelCode: "OH-VEST-BLK",
    price: 299000,
    image: "/assets/apparel-aksesoris/apparel/ONEHEARTVESTBLACK.webp",
    imageAlt: "One Heart Vest Black",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    specifications: [
      { label: "Material", value: "Twill 7S & mesh lining" },
      { label: "Finishing", value: "YKK zipper pocket & patch" }
    ]
  },
  {
    id: 16,
    name: "One Heart Oversized T-Shirt Black",
    category: "Apparel",
    categoryId: "shirt",
    description:
      "Kaos oversized One Heart Honda dengan bahan nyaman.",
    apparelCode: "OH-TS-OVR",
    price: 199000,
    image: "/assets/apparel-aksesoris/apparel/ONEHEARTOVERSIZEDT-SHIRTBLACK.webp",
    imageAlt: "One Heart Oversized T-Shirt Black",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    specifications: [
      { label: "Material", value: "Dan Bowl 200" },
      { label: "Finishing", value: "Rubber print" }
    ]
  },
  {
    id: 17,
    name: "HRC24 RWB Dryfit Polo",
    category: "Apparel",
    categoryId: "shirt",
    description:
      "Polo shirt HRC Honda Racing dengan material dryfit.",
    apparelCode: "HRC24-POLO-RWB",
    price: 360000,
    image: "/assets/apparel-aksesoris/apparel/HRC24RWBDryfitPolo.webp",
    imageAlt: "HRC24 RWB Dryfit Polo",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    specifications: [
      { label: "Material", value: "Pique knit jersey (Nylon & Spandex)" },
      { label: "Finishing", value: "Rubber print logo" }
    ]
  },
  {
    id: 18,
    name: "HRC23 Sporty Navy Polo Shirt",
    category: "Apparel",
    categoryId: "shirt",
    description:
      "Polo shirt HRC Honda Racing dengan tema sporty.",
    apparelCode: "HRC23-POLO-SPT",
    price: 195000,
    image: "/assets/apparel-aksesoris/apparel/HRC23SPORTYNAVYPOLO SHIRT.webp",
    imageAlt: "HRC23 Sporty Navy Polo Shirt",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    specifications: [
      { label: "Material", value: "Lacoste CVC Navy" },
      { label: "Finishing", value: "HD, rubber & plastisol print" }
    ]
  },
  {
    id: 19,
    name: "HRC23 Elegant Navy Polo Shirt",
    category: "Apparel",
    categoryId: "shirt",
    description:
      "Polo shirt HRC Honda Racing dengan tema elegant.",
    apparelCode: "HRC23-POLO-ELG",
    price: 180000,
    image: "/assets/apparel-aksesoris/apparel/HRC23ELEGANTNAVYPOLOSHIRT.webp",
    imageAlt: "HRC23 Elegant Navy Polo Shirt",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    specifications: [
      { label: "Material", value: "Lacoste CVC Navy" },
      { label: "Finishing", value: "High density & rubber print" }
    ]
  },
  {
    id: 20,
    name: "HRC22 Polo Shirt",
    category: "Apparel",
    categoryId: "shirt",
    description:
      "Polo shirt HRC Honda Racing dengan desain klasik.",
    apparelCode: "HRC22-POLO",
    price: 280000,
    image: "/assets/apparel-aksesoris/apparel/HRC22PoloShirt.webp",
    imageAlt: "HRC22 Polo Shirt Honda Racing",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: ["Black"],
    specifications: [
      { label: "Material", value: "Cotton pique" },
      { label: "Design", value: "All logo embroidery" }
    ]
  },
  {
    id: 21,
    name: "HRC22 Black Shirt",
    category: "Apparel",
    categoryId: "shirt",
    description:
      "Kemeja pit crew HRC Honda Racing dengan desain fungsional.",
    apparelCode: "HRC22-SHIRT",
    price: 270000,
    image: "/assets/apparel-aksesoris/apparel/HRC22BlackShirt.webp",
    imageAlt: "HRC22 Black Shirt Honda Racing",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: ["Black"],
    specifications: [
      { label: "Material", value: "Taipan drill" },
      { label: "Detail", value: "Dual front pocket, embroidered logo" }
    ]
  },
  {
    id: 22,
    name: "HRC22 RWB Polo Shirt",
    category: "Apparel",
    categoryId: "shirt",
    description:
      "Polo shirt HRC Honda Racing dengan material quick dry.",
    apparelCode: "HRC22-POLO-RWB",
    price: 357000,
    image: "/assets/apparel-aksesoris/apparel/HRC22RWBPoloShirt.webp",
    imageAlt: "HRC22 RWB Polo Shirt",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: ["Red", "White", "Blue"],
    specifications: [
      { label: "Material", value: "Reverse mesh polyester" },
      { label: "Feature", value: "Quick dry & breathable" }
    ]
  },
  {
    id: 23,
    name: "Honda Base Layer",
    category: "Apparel",
    categoryId: "shirt",
    description:
      "Base layer Honda yang pas di badan dan cepat kering.",
    apparelCode: "HON-BSL",
    price: 249500,
    image: "/assets/apparel-aksesoris/apparel/HondaBaseLayer.webp",
    imageAlt: "Honda Base Layer",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    specifications: [
      { label: "Material", value: "Polyester spandex" },
      { label: "Fit", value: "Body fit" }
    ]
  },
  {
    id: 24,
    name: "Honda CRF Jersey Top",
    category: "Apparel",
    categoryId: "jersey",
    description:
      "Jersey top Honda CRF dengan material dryfit untuk aktivitas off-road.",
    apparelCode: "CRF-JRS-TOP",
    price: 254500,
    image: "/assets/apparel-aksesoris/apparel/HondaCRFJerseyTop.webp",
    imageAlt: "Honda CRF Jersey Top",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["M", "L", "XL", "XXL"],
    specifications: [
      { label: "Material", value: "Polimesh dryfit" },
      { label: "Feature", value: "Quick dry & breathable" }
    ]
  },
  {
    id: 25,
    name: "Sporty Long Sleeve T-Shirt",
    category: "Apparel",
    categoryId: "shirt",
    description:
      "Kaos lengan panjang Honda dengan tema sporty.",
    apparelCode: "APP-SPT-LS",
    price: 132500,
    image: "/assets/apparel-aksesoris/apparel/SPORTYLONGSLEEVET-SHIRT.webp",
    imageAlt: "Sporty Long Sleeve T-Shirt Honda",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    specifications: [
      { label: "Material", value: "Cotton combed 30S" },
      { label: "Design", value: "Sporty theme" }
    ]
  },
  {
    id: 26,
    name: "Honda CRF Jersey Set",
    category: "Apparel",
    categoryId: "jersey",
    description:
      "Set jersey Honda CRF untuk aktivitas off-road dengan material ringan, breathable, dan cepat kering untuk kenyamanan maksimal.",
    apparelCode: "CRF-JRS-SET",
    price: 966500,
    image: "/assets/apparel-aksesoris/apparel/HondaCRFJerseySet.webp",
    imageAlt: "Honda CRF Jersey Set",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["M", "L", "XL", "XXL"],
    specifications: [
      { label: "Material", value: "Polyester spandex & polimesh dryfit" },
      { label: "Feature", value: "Menyerap keringat & cepat kering" }
    ]
  },
  {
    id: 27,
    name: "Travel Backpack",
    category: "Aksesoris",
    categoryId: "bag",
    description:
      "Tas ransel Honda dengan desain fungsional dan material tahan air untuk kebutuhan perjalanan.",
    price: 475000,
    image: "/assets/apparel-aksesoris/aksesoris/TravelBackpack.webp",
    imageAlt: "Honda Travel Backpack",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["All Size"],
    colors: ["Black"],
    specifications: [
      { label: "Material", value: "900D Coated Film & PU Leather" },
      { label: "Feature", value: "Water resistance, magnetic buckle, multiple compartment" },
      { label: "Dimension", value: "40 x 52 cm" }
    ]
  },
  {
    id: 28,
    name: "Elegant Gloves",
    category: "Aksesoris",
    categoryId: "gloves",
    description:
      "Sarung tangan Honda dengan desain elegan dan material premium untuk kenyamanan berkendara.",
    price: 370000,
    image: "/assets/apparel-aksesoris/aksesoris/ElegantGloves.webp",
    imageAlt: "Honda Elegant Gloves",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["M", "L", "XL"],
    colors: ["Red", "White", "Black"],
    specifications: [
      { label: "Body", value: "Polyurethane Synthetic Leather" },
      { label: "Palm", value: "Katai Suede Microfiber" }
    ]
  },
  {
    id: 29,
    name: "Honda Arm Cover",
    category: "Aksesoris",
    categoryId: "arm-cover",
    description:
      "Arm cover Honda yang nyaman dipakai dan cepat kering.",
    price: 92000,
    image: "/assets/apparel-aksesoris/aksesoris/HondaArmCover.webp",
    imageAlt: "Honda Arm Cover",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["M", "L"],
    specifications: [
      { label: "Material", value: "Katun lycra spandex & silikon inner" },
      { label: "Feature", value: "Menyerap keringat & cepat kering" }
    ]
  },
  {
    id: 30,
    name: "Honda Camo Headwear",
    category: "Aksesoris",
    categoryId: "headwear",
    description:
      "Headwear Honda bermotif camo dengan material elastis dan nyaman.",
    price: 86500,
    image: "/assets/apparel-aksesoris/aksesoris/HondaCamoHeadwear.webp",
    imageAlt: "Honda Camo Headwear",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["All Size"],
    colors: ["Camo"],
    specifications: [
      { label: "Material", value: "Microfiber polyester" },
      { label: "Dimension", value: "24.5 x 46 cm" }
    ]
  },
  {
    id: 31,
    name: "Honda CRF Print Glove",
    category: "Aksesoris",
    categoryId: "gloves",
    description:
      "Sarung tangan Honda CRF dengan desain off-road.",
    price: 142500,
    image: "/assets/apparel-aksesoris/aksesoris/HondaCRFPrintGlove.webp",
    imageAlt: "Honda CRF Print Glove",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["M", "L", "XL"],
    specifications: [
      { label: "Design", value: "Off-road theme" },
      { label: "Feature", value: "Nyaman & adem" }
    ]
  },
  {
    id: 32,
    name: "Honda CRF Snapback Cap Red",
    category: "Aksesoris",
    categoryId: "cap",
    description:
      "Topi snapback Honda CRF dengan desain off-road.",
    price: 102000,
    image: "/assets/apparel-aksesoris/aksesoris/HondaCRFSnapbackCap(Red).webp",
    imageAlt: "Honda CRF Snapback Cap Red",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["All Size"],
    colors: ["Red"],
    specifications: [
      { label: "Model", value: "Snapback" }
    ]
  },
  {
    id: 33,
    name: "Honda Leather Keychain",
    category: "Aksesoris",
    categoryId: "keychain",
    description:
      "Gantungan kunci Honda berbahan kulit sintetis dengan tampilan premium.",
    price: 57000,
    image: "/assets/apparel-aksesoris/aksesoris/HondaLeatherKeychain.webp",
    imageAlt: "Honda Leather Keychain",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["All Size"],
    colors: ["Dark Silver Chrome"],
    specifications: [
      { label: "Material", value: "Synthetic leather" },
      { label: "Size", value: "6–7 cm" }
    ]
  },
  {
    id: 34,
    name: "Honda Optima Sling Bag",
    category: "Aksesoris",
    categoryId: "bag",
    description:
      "Sling bag Honda Optima dengan desain praktis.",
    price: 320500,
    image: "/assets/apparel-aksesoris/aksesoris/HondaOptimaSlingBag.webp",
    imageAlt: "Honda Optima Sling Bag",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["All Size"],
    specifications: [
      { label: "Volume", value: "10L" }
    ]
  },
  {
    id: 35,
    name: "HRC22 Keychain",
    category: "Aksesoris",
    categoryId: "keychain",
    description:
      "Gantungan kunci HRC Honda Racing dengan desain eksklusif.",
    price: 46000,
    image: "/assets/apparel-aksesoris/aksesoris/HRC22Keychain.webp",
    imageAlt: "HRC22 Keychain",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    specifications: [
      { label: "Material", value: "Webbing polyester & rubber" }
    ]
  },
  {
    id: 36,
    name: "HRC23PouchBag",
    category: "Aksesoris",
    categoryId: "bag",
    description:
      "Pouch bag HRC Honda Racing untuk kebutuhan harian.",
    price: 190000,
    image: "/assets/apparel-aksesoris/aksesoris/HRC23POUCHBAG.webp",
    imageAlt: "HRC23 Pouch Bag",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["All Size"],
    specifications: [
      { label: "Material", value: "Nylon 600 & Oscar" },
      { label: "Finishing", value: "HD print logo" }
    ]
  },
  {
    id: 37,
    name: "HRC23SportyNavyCap",
    category: "Aksesoris",
    categoryId: "cap",
    description:
      "Topi HRC Honda Racing dengan desain sporty navy.",
    price: 120000,
    image: "/assets/apparel-aksesoris/aksesoris/HRC23SPORTYNAVYCAP.webp",
    imageAlt: "HRC23 Sporty Navy Cap",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["All Size"],
    specifications: [
      { label: "Material", value: "Lotto laminating & jala Korea" },
      { label: "Adjuster", value: "Double buckle" }
    ]
  },
  {
    id: 38,
    name: "HRC23 Tumbler",
    category: "Aksesoris",
    categoryId: "tumbler",
    description:
      "Tumbler HRC Honda Racing berbahan stainless steel.",
    price: 195000,
    image: "/assets/apparel-aksesoris/aksesoris/HRC23TUMBLER.webp",
    imageAlt: "HRC23 Tumbler",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    specifications: [
      { label: "Material", value: "Stainless steel" }
    ]
  },
  {
    id: 39,
    name: "HRC23WalletCard",
    category: "Aksesoris",
    categoryId: "wallet",
    description:
      "Dompet kartu HRC Honda Racing dengan desain eksklusif.",
    price: 95000,
    image: "/assets/apparel-aksesoris/aksesoris/HRC23WALLETCARD.webp",
    imageAlt: "HRC23 Wallet Card",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    specifications: [
      { label: "Material", value: "D600 & PU leather" }
    ]
  },
  {
    id: 40,
    name: "HRC24RWBCap",
    category: "Aksesoris",
    categoryId: "cap",
    description:
      "Topi HRC 2024 dengan warna Red White Blue.",
    price: 150000,
    image: "/assets/apparel-aksesoris/aksesoris/HRC24RWBCap.webp",
    imageAlt: "HRC24 RWB Cap",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["All Size"],
    colors: ["Red", "White", "Blue"],
    specifications: [
      { label: "Material", value: "Canvas" }
    ]
  },
  {
    id: 41,
    name: "HRC24 RWB Slingbag",
    category: "Aksesoris",
    categoryId: "bag",
    description:
      "Sling bag HRC 2024 dengan material tahan air.",
    price: 300000,
    image: "/assets/apparel-aksesoris/aksesoris/HRC24RWBSlingbag.webp",
    imageAlt: "HRC24 RWB Slingbag",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    specifications: [
      { label: "Material", value: "900D coated film" },
      { label: "Feature", value: "Water resistance & multiple pocket" },
      { label: "Size", value: "38 x 17 x 7 cm" }
    ]
  },
  {
    id: 42,
    name: "HRC24 RWBTravelUmbrella",
    category: "Aksesoris",
    categoryId: "umbrella",
    description:
      "Payung travel HRC 2024 dengan fitur auto open & close.",
    price: 250000,
    image: "/assets/apparel-aksesoris/aksesoris/HRC24RWBTravelUmbrella.webp",
    imageAlt: "HRC24 RWB Travel Umbrella",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    specifications: [
      { label: "Material", value: "190T pongee & fiberglass ribs" },
      { label: "Feature", value: "UV protection & auto open close" }
    ]
  },
  {
    id: 43,
    name: "HRR Daily Glove Red",
    category: "Aksesoris",
    categoryId: "gloves",
    description:
      "Sarung tangan Honda Racing Red untuk penggunaan harian.",
    price: 137500,
    image: "/assets/apparel-aksesoris/aksesoris/HRRDAILYGLOVERED.webp",
    imageAlt: "HRR Daily Glove Red",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["S", "M", "L", "XL", "XXL"],
    specifications: [
      { label: "Design", value: "Honda Racing Red" }
    ]
  },
  {
    id: 44,
    name: "Mix Material Gloves",
    category: "Aksesoris",
    categoryId: "gloves",
    description:
      "Sarung tangan Honda dengan material mix dan fitur touchscreen.",
    price: 350000,
    image: "/assets/apparel-aksesoris/aksesoris/MixMaterialGloves.webp",
    imageAlt: "Mix Material Gloves Honda",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["M", "L", "XL"],
    colors: ["Black"],
    specifications: [
      { label: "Material", value: "Microfiber" },
      { label: "Feature", value: "Touchscreen compatible" }
    ]
  },
  {
    id: 45,
    name: "One Heart Elegant Gloves Red White",
    category: "Aksesoris",
    categoryId: "gloves",
    description:
      "Sarung tangan One Heart dengan kombinasi warna merah dan putih.",
    price: 175000,
    image: "/assets/apparel-aksesoris/aksesoris/OneHeartElegantGlovesRedWhite.webp",
    imageAlt: "One Heart Elegant Gloves Red White",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    sizes: ["M", "L", "XL"],
    specifications: [
      { label: "Material", value: "Polyester knitted & ultra fine silicone printing" }
    ]
  },
  {
    id: 46,
    name: "One Heart Phone Stand Tumbler",
    category: "Aksesoris",
    categoryId: "tumbler",
    description:
      "Tumbler One Heart dengan fitur phone stand dan hand carry.",
    price: 210000,
    image: "/assets/apparel-aksesoris/aksesoris/ONEHEARTPHONESTANDTUMBLER.webp",
    imageAlt: "One Heart Phone Stand Tumbler",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    specifications: [
      { label: "Material", value: "Stainless steel food grade" },
      { label: "Volume", value: "550 ml" },
      { label: "Feature", value: "BPA free & phone stand holder" }
    ]
  },
  {
    id: 47,
    name: "Smart Key Remote Cover",
    category: "Aksesoris",
    categoryId: "key-cover",
    description:
      "Cover smart key Honda untuk tampilan lebih premium.",
    price: 59500,
    image: "/assets/apparel-aksesoris/aksesoris/SMARTKEYREMOTECOVER.webp",
    imageAlt: "Smart Key Remote Cover Honda",
    isGenuine: true,
    isNew: true,
    warranty: "—",
    colors: ["Black"],
    specifications: [
      { label: "Material", value: "ABS plastic" }
    ]
  },

];



  const filteredApparel = useMemo(() => {
    let result = apparel;

    if (activeCategory !== 'all') {
      result = result.filter((o) => o.categoryId === activeCategory);
    }

    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      result = result.filter((o) =>
        o.name.toLowerCase().includes(q) ||
        (o.apparelCode && o.apparelCode.toLowerCase().includes(q)) ||
        o.category.toLowerCase().includes(q) ||
        o.description.toLowerCase().includes(q)
      );
    }

    return result;
  }, [activeCategory, searchQuery, apparel]);

  const totalPages = Math.ceil(filteredApparel.length / ITEMS_PER_PAGE);

  const paginatedApparel = useMemo(() => {
    const start = (currentPage - 1) * ITEMS_PER_PAGE;
    return filteredApparel.slice(start, start + ITEMS_PER_PAGE);
  }, [filteredApparel, currentPage]);



  const handleConsult = (apparel) => {
    const message = `Halo, saya tertarik dengan ${apparel?.name} (${apparel?.apparelCode}). Apakah masih tersedia?`;
    window.open(`https://wa.me/6288293642972?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <>
      <Header />
      <main className="min-h-screen bg-background pb-24">
        <section className="bg-gradient-to-br from-primary to-accent py-12 md:py-16 lg:py-20">
            <div className="container mx-auto px-4">
              <div className="max-w-4xl mx-auto text-center">

                <div className="inline-flex items-center space-x-2 bg-primary-foreground/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
                  <Icon name="Package" size={20} color="white" />
                  <span className="text-sm font-heading font-semibold text-primary-foreground">
                    Genuine Honda Apparel & Accessories
                  </span>
                </div>

                <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-primary-foreground mb-4">
                  Apparel & Aksesoris Honda
                </h1>

                <p className="text-base md:text-lg text-white mb-8 max-w-2xl mx-auto">
                  Lengkapi gaya berkendara Anda dengan apparel dan aksesoris original Honda.
                  Tersedia riding gear dan lifestyle item dengan kualitas dan desain premium.
                </p>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">

                  {/* BUTTON 1 — INFO & PEMESANAN */}
                  <Button
                    size="lg"
                    iconName="MessageCircle"
                    iconPosition="left"
                    onClick={() =>
                      window.open(
                        "https://wa.me/6288293642972?text=" +
                          encodeURIComponent(
                            "Halo Admin 👋\n\n" +
                            "Saya tertarik untuk Info & Pemesanan apparel/aksesoris Honda.\n" +
                            "Mohon info produk yang tersedia beserta harga dan detailnya ya.\n\n" +
                            "Terima kasih 🙏"
                          ),
                        "_blank"
                      )
                    }
                    className="bg-black text-white hover:bg-white hover:text-black transition-colors duration-300"
                  >
                    Info & Pemesanan
                  </Button>

                  {/* BUTTON 2 — CEK KETERSEDIAAN */}
                  <Button
                    size="lg"
                    iconName="PackageCheck"
                    iconPosition="left"
                    onClick={() =>
                      (window.location.href = "/produk/apparel-aksesoris")
                    }
                    className="bg-white text-black border border-white hover:bg-black hover:text-white transition-colors duration-300"
                  >
                    Cek Ketersediaan
                  </Button>

                </div>
              </div>
            </div>
          </section>

        <section ref={catalogRef} className="py-8 md:py-12 lg:py-16">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
              <div className="lg:col-span-1 space-y-6">

                <CategoryFilter
                  activeCategory={activeCategory}
                  onCategoryChange={setActiveCategory} />


                <div className="bg-card rounded-lg p-4 md:p-6 shadow-card-hover">
                  <h3 className="text-lg font-heading font-bold text-foreground mb-4 flex items-center space-x-2">
                    <Icon name="Info" size={20} color="var(--color-primary)" />
                    <span>Informasi Penting</span>
                  </h3>
                  <div className="space-y-3 text-sm text-muted-foreground">
                    <div className="flex items-start space-x-2">
                      <Icon name="Shield" size={16} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                      <p>Semua Apparel Honda Berdikari Pamulang Genuine Honda</p>
                    </div>
                    <div className="flex items-start space-x-2">
                      <Icon name="Truck" size={16} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                      <p>Pengiriman tersedia untuk area Tangerang Selatan</p>
                    </div>
                    <div className="flex items-start space-x-2">
                      <Icon name="CheckCircle" size={16} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                      <p>Pemasangan gratis untuk pembelian di Honda Berdikari</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="lg:col-span-2 space-y-6">
                <div className="bg-card rounded-lg p-4 md:p-6 shadow-card-hover">
                  <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
                    <div>
                      <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground mb-2">
                        Katalog Produk
                      </h2>
                      <p className="text-sm text-muted-foreground">
                        Menampilkan {filteredApparel?.length} dari {apparel?.length} produk
                      </p>
                    </div>
                    
                  </div>

                  <SearchBar
                    value={searchQuery}
                    onChange={setSearchQuery}
                    onClear={() => setSearchQuery("")}
                    placeholder="Cari apparel atau aksesoris..."
                  />


                </div>

                {filteredApparel?.length > 0 ?
                <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">
                    {paginatedApparel?.map((apparel) =>
                  <ApparelCard
                    key={apparel?.id}
                    apparel={apparel}
                    onConsult={handleConsult}
                    onViewDetails={setSelectedApparel} />
                  )}
                </div> :

                

                <div className="bg-card rounded-lg p-8 md:p-12 text-center shadow-card-hover">
                    <div className="w-20 h-20 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
                      <Icon name="Search" size={40} color="var(--color-muted-foreground)" />
                    </div>
                    <h3 className="text-xl font-heading font-bold text-foreground mb-2">
                      Tidak Ada Hasil
                    </h3>
                    <p className="text-muted-foreground mb-6">
                      Maaf, tidak ada produk yang sesuai dengan pencarian Anda.
                      Coba ubah kata kunci atau filter yang digunakan.
                    </p>
                    <Button
                    variant="outline"
                    size="default"
                    iconName="RotateCcw"
                    iconPosition="left"
                    onClick={() => {
                      setSearchQuery('');
                      setActiveCategory('all');
                      setCurrentPage(1);
                    }}
                    >
                    
                      Reset Semua Filter
                    </Button>
                  </div>

                  
                }

                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />

              </div>
            </div>
          </div>
        </section>

        <section
          className="py-8 md:py-12 lg:py-16 bg-muted"
          data-aos="fade-up"
          data-aos-delay="150"
        >
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-8 md:mb-12">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-4">
                  Mengapa Pilih Apparel & Aksesoris Original Honda?
                </h2>
                <p className="text-muted-foreground">
                  Perpaduan gaya, kenyamanan, dan perlindungan untuk setiap perjalanan Anda
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {/* CARD 1 */}
                <div className="bg-card rounded-lg p-6 text-center shadow-card-hover">
                  <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon name="Shield" size={32} color="var(--color-primary)" />
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground mb-2">
                    Original & Terjamin
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Apparel dan aksesoris Honda original dengan kualitas teruji untuk keamanan dan kenyamanan berkendara.
                  </p>
                </div>

                {/* CARD 2 */}
                <div className="bg-card rounded-lg p-6 text-center shadow-card-hover">
                  <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon name="CheckCircle" size={32} color="var(--color-primary)" />
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground mb-2">
                    Nyaman & Fungsional
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Dirancang sesuai kebutuhan pengendara, nyaman digunakan harian maupun perjalanan jarak jauh.
                  </p>
                </div>

                {/* CARD 3 */}
                <div className="bg-card rounded-lg p-6 text-center shadow-card-hover">
                  <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon name="Sparkles" size={32} color="var(--color-primary)" />
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground mb-2">
                    Desain Stylish
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Tampil lebih percaya diri dengan desain modern yang mendukung gaya riding Anda.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="py-8 md:py-12 lg:py-16"
          data-aos="zoom-in-up"
          data-aos-delay="150"
        >
          <div className="container mx-auto px-4">
            <div className="bg-gradient-to-br from-primary to-accent rounded-lg p-6 md:p-8 lg:p-12 text-center">
              <div className="max-w-3xl mx-auto">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-primary-foreground mb-4">
                  Lengkapi Gaya Riding Anda
                </h2>

                <p className="text-base md:text-lg text-white mb-8">
                  Tampil lebih percaya diri saat berkendara dengan pilihan apparel dan
                  aksesoris Honda yang nyaman, fungsional, dan bergaya.
                  Konsultasikan kebutuhan Anda bersama tim kami.
                </p>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                  {/* BUTTON 1 — CHAT WHATSAPP */}
                  <Button
                    size="lg"
                    iconName="MessageCircle"
                    iconPosition="left"
                    onClick={() =>
                      window.open(
                        "https://wa.me/6288293642972?text=" +
                          encodeURIComponent(
                            "Halo Admin 👋\n\n" +
                            "Saya ingin *konsultasi* terkait apparel dan aksesoris Honda.\n" +
                            "Mohon bantu rekomendasi produk yang sesuai dengan kebutuhan dan gaya riding saya.\n\n" +
                            "Terima kasih 🙏"
                          ),
                        "_blank"
                      )
                    }
                    className="
                      bg-black text-white
                      hover:bg-white hover:text-black
                      transition-all duration-300
                      hover:scale-[1.03]
                    "
                  >
                    Chat WhatsApp
                  </Button>

                  {/* BUTTON 2 — HUBUNGI KAMI (WHATSAPP) */}
                  <Button
                    size="lg"
                    iconName="Phone"
                    iconPosition="left"
                    onClick={() =>
                      window.open(
                        "https://wa.me/6288293642972?text=" +
                          encodeURIComponent(
                            "Halo Admin 👋\n\n" +
                            "Saya tertarik dengan *apparel & aksesoris Honda*.\n" +
                            "Mohon info lebih lanjut terkait produk, ketersediaan, dan detail pemesanannya.\n\n" +
                            "Terima kasih 🙏"
                          ),
                        "_blank"
                      )
                    }
                    className="
                      bg-white/90 text-black
                      border border-white
                      hover:bg-black hover:text-white
                      transition-all duration-300
                      hover:scale-[1.03]
                    "
                  >
                    Hubungi Kami
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </section>


      </main>
      <Footer />
      {selectedApparel &&
      <ApparelDetailModal
        apparel={selectedApparel}
        onClose={() => setSelectedApparel(null)}
        onConsult={handleConsult} />

      }
    </>);

};

export default ApparelAndAccessories;